export class ModalEditarEncomendaController {
  constructor($scope, $state, $uibModalInstance, encomendaId) {
    'ngInject';

    $scope.encomendaId = encomendaId;

    $scope.confirmar = function() {
      $uibModalInstance.close({});
      $state.go('editar', { idEncomenda: $scope.encomendaId });
    };

    $scope.voltar = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }
}
